import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../common/Constants";
import { IIndexTypeCategory } from "../model/IndexTypeCategory";
import IndexTypeCategoryMapper from "../service/IndexTypeCategoryMapper";
import IndexTypeCategoryParamMapper from "../service/IndexTypeCategoryParamMapper";

export default class CreateIndexTypeCategoryInteractor {
  private createResource: CreateResourceInteractor<IIndexTypeCategory>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IIndexTypeCategory) {
    return this.createResource.execute(
      Constants.indexCategoryBasePath,
      IndexTypeCategoryMapper,
      IndexTypeCategoryParamMapper,
      model
    );
  }
}
